import { useEffect, useRef, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import {
  Box,
  CardActionArea,
  CardContent,
  Grid,
  Container,
  Typography,
  Card,
  ThemeProvider,
  createTheme,
  CardMedia,
  makeStyles,
  Avatar,
  Button,
  Tooltip,
} from "@mui/material";

import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

const AppChipLabel = (props) => {
  const { appCode } = props;

  return (
    <MDBox
      // variant=""
      bgColor={"primary"}
      color={"white"}
      // coloredShadow={"primary"}
      borderRadius={"2rem"}
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.1rem"
      height="1.5rem"
    >
      <MDTypography
        variant="button"
        fontSize="0.9rem"
        fontWeight="bold"
        color="white"
      >
        {appCode}
      </MDTypography>
    </MDBox>
  );
};

AppChipLabel.propTypes = {};
AppChipLabel.defaultProps = {
  appCode: "APP",
};
export default AppChipLabel;
